import { Injectable } from '@angular/core';
import { WebppSocketService } from './webppSocket.service';

@Injectable({
  providedIn: 'root',
})
export class WebappSubscriptionService {
  subscriptionList = [];

  constructor(private readonly socket: WebppSocketService) {
    this.socket.listenEvent.subscribe((message) => this.handleSubscription(message));
  }

  private readonly handleSubscription = (message) => {
    const callbackList = this.subscriptionList?.filter((s) => s.channel === message.type);
    callbackList?.forEach((c) => {
      c.callback(message);
    });
  };

  public addSubscription = (callback, channel) => {
    // Registrar dos veces el mismo par hace que cada mensaje se procese dos veces.
    if (this.subscriptionList.some((s) => s.channel === channel && s.callback === callback)) return;

    this.subscriptionList.push({ callback, channel });
  };

  public closeSubscription = (callback, channel) => {
    // Hay que descartar sólo la entrada pedida: con && se conservaba justamente esa y se
    // eliminaban las demás.
    this.subscriptionList = this.subscriptionList.filter((s) => !(s.channel === channel && s.callback === callback));
  };
}
